import React from "react";
import Tabs from "../../connectui/component/input/Tabs";

const TabsExample = () => {
  return (
    <div>
      <h3>Tabs Component Example</h3>
      <Tabs labels={["Tab 1", "Tab 2", "Tab 3"]}>
        <div>Content for Tab 1</div>
        <div>Content for Tab 2</div>
        <div>Content for Tab 3</div>
      </Tabs>
    </div>
  );
};

export default TabsExample;
